import { ReducerCreators } from '@reduxjs/toolkit';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelState } from './types';
import { FetchRegistrationQuestions } from '@/connection/channel/channel';
import toastTrigger from '@ui/toast/toast-trigger';

export const reducers = (create: ReducerCreators<ChannelState>) => ({
  fetchRegistrationQuestions: create.asyncThunk(
    async (data: { channel: number }, { rejectWithValue }) => {
      try {
        const { channel } = data || {};
        const results = await FetchRegistrationQuestions(channel);

        if (!results) {
          return rejectWithValue('No channels found');
        }
        if ('error' in results) {
          return rejectWithValue(serializeError(results.error));
        }

        return results;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.registrationQuestions = action.payload;
        }
        state.loadingRegistrationQuestions = false;
      },
      pending: (state) => {
        state.loadingRegistrationQuestions = true;
      },
      rejected: (state) => {
        state.loadingRegistrationQuestions = false;
        toastTrigger(`<div class="S2">Error loading registration questions</div>`, {
          type: 'error',
        });
      },
    }
  ),
});
